import { IpponCard, IpponText, IpponVSpace } from '@ippon-ui/react';
import type { Optional } from '@/generic/functional';
import { useOptional } from '@/generic/react-tools';
import type { Description, Rule } from '@/rule/domain/Rule.ts';
import { type Example, ExampleCompliance } from '@/rule/domain/Example.ts';

const RuleDescriptionComponent = ({ description }: { description: Optional<Description> }) =>
  useOptional({
    optional: description,
    onValuated: (description) => (
      <IpponText
        variant="body"
        size="small"
        color="neutral-tertiary-inversed"
        dataSelector="rule.description"
      >
        {description.value}
      </IpponText>
    ),
  });

const complianceToColor = (compliance: ExampleCompliance) => {
  switch (compliance) {
    case ExampleCompliance.COMPLIANT:
      return 'success';
    case ExampleCompliance.NON_COMPLIANT:
      return 'error';
  }
};

const RuleExampleComponent = ({ example }: { example: Example }) => {
  const color = complianceToColor(example.compliance);

  return (
    <IpponCard dataSelector="rule.example" color={color}>
      <IpponVSpace gap={8}>
        <IpponText
          variant="body"
          size="small"
          weight="bold"
          dataSelector="rule.example.description"
        >
          {example.description}
        </IpponText>
        <IpponText variant="body" size="small" dataSelector="rule.example.snippet">
          {example.snippet}
        </IpponText>
      </IpponVSpace>
    </IpponCard>
  );
};

export const RuleDetailsComponent = ({ rule }: { rule: Rule }) => (
  <>
    <RuleDescriptionComponent description={rule.description} />
    {rule.examples.list.map((example) => (
      <RuleExampleComponent key={example.description} example={example} />
    ))}
  </>
);
